import { PAY_METHOD, type TPayMethod } from '@/hooks/use-pay/types';

const TRACKER_PAY_METHOD: Record<TPayMethod, string> = {
    [PAY_METHOD.APPLE_PAY]: 'apple',
    [PAY_METHOD.GOOGLE_PAY]: 'google',
    [PAY_METHOD.CARD]: 'card',
    [PAY_METHOD.PAYPAL]: 'paypal',
};

/** 展示中的全部支付方式 → BI 逗号分隔字符串（apple,google,card,paypal） */
export function formatPaymentGroup(methods: readonly TPayMethod[]): string {
    return methods.map(method => TRACKER_PAY_METHOD[method]).join(',');
}

/** 用户选中的支付方式 → BI 枚举（apple / google / card / paypal） */
export function formatPaymentMethod(method: TPayMethod | ''): string {
    return method ? TRACKER_PAY_METHOD[method] : '';
}
